var _templateObject, _templateObject2;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import styled, { css } from 'styled-components';
export var StyledTabPanel = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var index = _ref.index,
    value = _ref.value;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    display: ", ";\n  "])), index === value ? 'block' : 'none');
});